var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLegalCase1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 129,
    viewBox: "0 0 127 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1701_3002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 31.1047C10 19.4489 19.4489 10 31.1047 10H87.2758C98.9317 10 108.381 19.4489 108.381 31.1047V88.8953C108.381 100.551 98.9317 110 87.2758 110H31.1047C19.4489 110 10 100.551 10 88.8953V31.1047Z",
    fill: "#FBF8F0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 64,
    height: 64,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1701_3002",
    x: 0.151122,
    y: 0.151122,
    width: 126.521,
    height: 128.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 7.03491,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1701_3002"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.22095,
    dy: 4.22095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.51746
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1701_3002"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1701_3002",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1701_3002",
    transform: "scale(0.0104167)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1701_3002",
    width: 96,
    height: 96,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACkUlEQVR4nO2cvY7TQBRGj5AIy1IEWpo8BRJaUcEboSwE0vImtCsaCv4qukXaB4CGhwBRX2QpkSIT4zgZ+96Z+Y50u92Ndc544jjWghBCCCFEQs5T/jExjCXwA3g48PdEIvm2GUVwlG+K4C/fFMFfvinCuKwOkL+dtyMfS3UsB8i/AR54H3CtK/8amHsfcEkstfIlv0pWA1Z+M5+Bu94HXeO2YzvzFbjnffC1yjdF8JdviuAv3xTBX74pgr98UwR/+aYI/vJNEf7lcmL5ihBAvulMwF1+1REuA4ivNsKrAMKt1ht4U1/tmM6EfORbydvR0Pv5lsl2dB94THByWfk28EyYb75z/gM8Iyi5yreeCFv5258LGSF3+dYRoS0/ZIRS5FsrQpf8UBFuAe8CSLPE86VH/m6Ep94Rbh8Q4Rr4GEDsGNPsAESOcLN5XHAGvA8gLOWsCcS+CO1nNWcFRQglf1+ErgdlZwVECCl/N8Kbngdlz4APAUQeM80n/SKYZXgmhF75pUdYUyhnGVyiFrPt7KPvE6f3vKRg5sHlF7vtNEi+I3OtfMk3bTv07sHf9Ybrt+2sJ/6coDdc9suYIoLk838ZY0aQfA6TMUYEyWeYjJQRJJ/jZKSIIPmcJuPOCREknzR3GZu7qJ8Gyn9BwRxznT/l672mYCQ/I/mrBK/3TdvOcfLXE8fWtpNw5TdcaeX7rPwtC+CnLjV95B8aQdf5E8hYdESQ/AllLFoRJN9BxmITQfITX+0Moeh/1up1tSMk3xetfEck3xHJdyQ3+RZsTuYR8Duj5+Ut2CThAvgVfOVvKTJAX4Qo8ik5QFeESPIpPUA7QjT51BCg4QnwnJhYsKkOCzZCCCGEEEIIIYQQQtDwF8ETCv1WgYWPAAAAAElFTkSuQmCC"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalCase1);
export default __webpack_public_path__ + "static/media/LegalCase1.f8d42010937c3d1de35565765359b868.svg";
export { ForwardRef as ReactComponent };